import { MobileSortDrawer as GenericSortDrawer } from '@components/MobileSortDrawer/MobileSortDrawer';
import { LibrarySortByHash } from '@stores/LibraryManager/LibraryManager';
import { observer } from 'mobx-react';
import { usePinnedFirstToggle } from '../../hooks/usePinnedFirstToggle';
import { LIBRARY_SORT_GROUPS_MOBILE } from '../../utils/sortOptions';

type MobileSortDrawerProps = {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  selectedSort: LibrarySortByHash;
  onSelect: (value: LibrarySortByHash) => void;
};

/**
 * `observer` because `usePinnedFirstToggle` reads the preference from the store — which is also
 * why the toggle isn't threaded down from `MobileLibrariesOverlay` as a prop.
 */
export const MobileSortDrawer = observer(function MobileSortDrawer({
  open,
  onClose,
  onOpen,
  selectedSort,
  onSelect,
}: MobileSortDrawerProps) {
  const pinnedFirstToggle = usePinnedFirstToggle();

  return (
    <GenericSortDrawer
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      groups={LIBRARY_SORT_GROUPS_MOBILE}
      selectedKey={selectedSort}
      onSelect={onSelect}
      toggle={pinnedFirstToggle}
    />
  );
});
